import { API_BASE_URL, HEADERS_WITH_TOKEN } from 'services/api/BaseUrl'

export const getAll = () =>
  fetch(
    `${API_BASE_URL}/products`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  .then(res => res.json())


export const save = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/products`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const storeBulk = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/store-bulk/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const edit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const remove = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/delete/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const getProductsBySubcategory = async (id, menu) => {
  const res = await fetch(
    `${API_BASE_URL}/products/get-by-subcategory/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ menu })
    }
  )
  return await res.json()
}

export const updateOrder = async (data) => {
  const res = await fetch(
    `${API_BASE_URL}/products/update-order`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(data)
    }
  )
  return await res.json()
}

export const updateActive = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/update-active/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const updateVariants = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/update-variants/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const updateTags = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/update-tags/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const migrate = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/migrate/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const getProductTags = async () => {
  /* fetch(
    `${API_BASE_URL}/product-tags`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  .then(res => res.json()) */
  
  const usr = JSON.parse(localStorage.getItem('mqadusr'))
  const bo = JSON.parse(localStorage.getItem('mqBO'))

  const res = await fetch(
    `${API_BASE_URL}/product-tags?cmp=${usr.company._id}&bo=${bo._id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const copy = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/products/copy/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}